export { AutomatedResponses } from './AutomatedResponses';
